<template>
  <div class="skeleton-product-page">
    <the-skeleton class="skeleton-product-page__breadcrumbs" radius="8" />

    <div class="skeleton-product-page__wrapper">
      <the-skeleton
        class="skeleton-product-page__image"
        width="100%"
        radius="20"
      />

      <div class="skeleton-product-page__content">
        <the-skeleton class="skeleton-product-page__title" radius="8" />

        <the-skeleton
          class="skeleton-product-page__text"
          width="100%"
          radius="8"
        />

        <the-skeleton
          class="skeleton-product-page__compound"
          width="55"
          height="24"
          radius="8"
        />

        <the-skeleton
          class="skeleton-product-page__table"
          width="360"
          height="38"
          radius="8"
        />

        <div class="skeleton-product-page__footer">
          <the-skeleton class="skeleton-product-page__price" radius="8" />

          <the-skeleton class="skeleton-product-page__button" radius="100" />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.skeleton-product-page {
  &__breadcrumbs {
    width: 160px;
    height: 24px;
    margin-bottom: 26px;

    @include media('>=desktop-mini') {
      width: 360px;
      height: 16px;
      margin-bottom: 50px;
    }
  }

  &__wrapper {
    @include media('>=desktop-mini') {
      display: grid;
      grid-template-columns: 1fr 452px;
      gap: 70px;
      align-items: center;
    }
  }

  &__image {
    height: 233px;
    margin-bottom: 15px;

    @include media('>=desktop-mini') {
      height: 452px;
      margin-bottom: 0;
    }
  }

  &__title {
    width: 120px;
    height: 24px;
    margin-bottom: 40px;

    @include media('>=desktop-mini') {
      width: 160px;
      height: 33px;
    }
  }

  &__text {
    height: 38px;
    margin-bottom: 24px;

    @include media('>=desktop-mini') {
      height: 60px;
      margin-bottom: 40px;
    }
  }

  &__compound {
    display: none;
    margin-bottom: 20px;

    @include media('>=desktop-mini') {
      display: block;
    }
  }

  &__table {
    display: none;

    @include media('>=desktop-mini') {
      display: block;
    }
  }

  &__footer {
    display: flex;
    justify-content: space-between;
    margin-top: 24px;

    @include media('>=desktop-mini') {
      margin-top: 40px;
    }
  }

  &__price {
    width: 72px;
    height: 26px;

    @include media('>=desktop-mini') {
      width: 80px;
      height: 33px;
    }
  }

  &__button {
    width: 108px;
    height: 40px;

    @include media('>=desktop-mini') {
      width: 160px;
      height: 50px;
    }
  }
}
</style>
